import React from "react"
import { useTranslation } from "next-i18next"

import { NumericFormat } from "react-number-format"

import { getTranslations } from "@/components/Bundles/localization"

import BundleChildItems from "@/components/Bundles/StaticBundle/BundlesViewDetails/BundleChildItems"

import Style from "@/components/Bundles/StaticBundle/index.module.scss"

const StaticBundle = props => {
  const { isViewBundle = "", pdpView, data, page = "" } = props || {}
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)

  const { productPrice = 0, currencySign = "", lineItem = [] } = data

  const { includedPdpItemsLabel, subTotalItems = () => {} } = staticText

  // const percentOff = 100 - Math.round((productPrice / listPrice) * 100)
  const totalItems = lineItem.length

  return (
    <div className={Style.BundleSectionWrapper}>
      <div
        className={`bundles ${
          isViewBundle ? "preview-cart-bundles" : "fade-out"
        }`}
      >
        {pdpView ? (
          <p className="include-item">{includedPdpItemsLabel}</p>
        ) : null}
        <div className={`lists ${pdpView ? "pdp-bundle-lists" : ""}`}>
          {lineItem.map(item => (
            <React.Fragment key={item.id}>
              <BundleChildItems data={item} pdpView={pdpView} page={page} />
            </React.Fragment>
          ))}
        </div>
        {pdpView ? (
          <div className="bundles-bottom-section">
            <div className="price-section">
              <p className="subtotal">{subTotalItems(totalItems)}</p>
              <p className="bundles-total-price">
                <NumericFormat
                  value={productPrice}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={currencySign}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </p>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
export default StaticBundle
